import Auth from "./routes/Auth";
import React, { Suspense, useEffect, useRef } from "react";
import { routingData } from "./routes/routing";
import { Routes, Route, useLocation } from "react-router-dom";
import { trackMetaEvent, trackMetaPageView } from "./config/metaPixel";
import PageNotFound from "./pages/PageNotFound";
import RedirectRouter from "./routes/RedirectRouter";
import { UserProvider } from "./routes/Usercontext";
import { loadBootstrapCss, loadLegacyAppCss } from "./styles/loadDeferredStyles";

function RouteFallback() {
  return <div className="ux-route-fallback" aria-busy="true" aria-label="Loading page" />;
}

function DeferredStyleLoader() {
  const location = useLocation();
  const isFirstPageView = useRef(true);

  useEffect(() => {
    const path = location.pathname || "/";
    const isLanding = path === "/" || path === "";
    if (!isLanding) {
      loadBootstrapCss();
      loadLegacyAppCss();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (isFirstPageView.current) {
      isFirstPageView.current = false;
    } else {
      trackMetaPageView();
    }

    const path = (location.pathname || "").toLowerCase();
    if (path.includes("tenderdetail") || path.includes("guesttenderdetail")) {
      trackMetaEvent("ViewContent", {
        content_name: "Tender details",
        content_category: "tender",
        content_ids: [path],
      });
    }
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  const recursiveRouter = (props) => {
    const { nestedRoutes, routes, isProtected, role } = props;

    const authenticatedRouted = () => {
      return (
        <>
          {routes &&
            routes.map((e, index) => (
              <Route key={index} path={e.path} element={e.component} />
            ))}
          {nestedRoutes &&
            nestedRoutes.map((e, index) => (
              <Route path={e.path} element={e.component} key={index}>
                {recursiveRouter(e)}
              </Route>
            ))}
        </>
      );
    };

    return isProtected ? (
      <Route element={<Auth allowedRoles={role} />}>
        {authenticatedRouted()}
      </Route>
    ) : role === "" ? (
      <Route element={<RedirectRouter />}>{authenticatedRouted()}</Route>
    ) : (
      <>{authenticatedRouted()}</>
    );
  };

  useEffect(() => {
    function handleVisibilityChange() {
      if (document.visibilityState === "hidden") {
        localStorage.removeItem("session_token");
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  return (
    <UserProvider>
      <DeferredStyleLoader />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          {routingData.map((e, index) => {
            return (
              <React.Fragment key={index.toString()}>
                {recursiveRouter(e)}
              </React.Fragment>
            );
          })}

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>
    </UserProvider>
  );
}

export default App;
